module.exports = __webpack_public_path__ + "img/header_wave.cc803693.svg";